/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Happy_Wolf_RunInputs */

const en_keen_happy_wolf_run = /** @type {(inputs: Keen_Happy_Wolf_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intro logo`)
};

const de_keen_happy_wolf_run = /** @type {(inputs: Keen_Happy_Wolf_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intro-Logo`)
};

/**
* | output |
* | --- |
* | "Intro logo" |
*
* @param {Keen_Happy_Wolf_RunInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_happy_wolf_run = /** @type {((inputs?: Keen_Happy_Wolf_RunInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Happy_Wolf_RunInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_happy_wolf_run(inputs)
	return de_keen_happy_wolf_run(inputs)
});